if (!customElements.get('accordion-item')) {
  class AccordionItem extends HTMLElement {
    constructor() {
      super();

      this.toggleRef = this.toggle.bind(this);
      this.closeRef = this.close.bind(this);
    }

    /**
     * @param {MouseEvent} event - Click event
     */
    toggle(event) {
      event.preventDefault();
      this.classList.toggle('is-active');

      if (!this.hasAttribute('data-group-id')) return;
      document.dispatchEvent(
        new CustomEvent('exo:close-accordion-group', {
          detail: {
            groupId: this.getAttribute('data-group-id'),
            element: this,
          },
        }),
      );
    }

    close(event) {
      if (
        event.detail.groupId != this.getAttribute('data-group-id') ||
        event.detail.element == this
      )
        return;
      this.classList.remove('is-active');
    }

    disconnectedCallback() {
      if (this.head) this.head.removeEventListener('click', this.toggleRef);

      if (!this.hasAttribute('data-group-id')) return;
      document.removeEventListener('exo:close-accordion-group', this.closeRef);
    }

    connectedCallback() {
      /** @type {HTMLElement | null} */
      this.head = this.querySelector('.js-accordion-head');

      if (this.head) this.head.addEventListener('click', this.toggleRef);

      if (!this.hasAttribute('data-group-id')) return;
      document.addEventListener('exo:close-accordion-group', this.closeRef);
    }
  }

  customElements.define('accordion-item', AccordionItem);
}
